__turbopack_context__.v({
  "appear-slide-left": "TimelineSteps-module-scss-module__iBsB6a__appear-slide-left",
  "bounceTwice": "TimelineSteps-module-scss-module__iBsB6a__bounceTwice",
  "container": "TimelineSteps-module-scss-module__iBsB6a__container",
  "fade-in-bottom": "TimelineSteps-module-scss-module__iBsB6a__fade-in-bottom",
  "fade-in-left": "TimelineSteps-module-scss-module__iBsB6a__fade-in-left",
  "fade-in-right": "TimelineSteps-module-scss-module__iBsB6a__fade-in-right",
  "fadeIn": "TimelineSteps-module-scss-module__iBsB6a__fadeIn",
  "label": "TimelineSteps-module-scss-module__iBsB6a__label",
  "loader": "TimelineSteps-module-scss-module__iBsB6a__loader",
  "number": "TimelineSteps-module-scss-module__iBsB6a__number",
  "pathline": "TimelineSteps-module-scss-module__iBsB6a__pathline",
  "point": "TimelineSteps-module-scss-module__iBsB6a__point",
  "puff-in-center": "TimelineSteps-module-scss-module__iBsB6a__puff-in-center",
  "puff-in-left": "TimelineSteps-module-scss-module__iBsB6a__puff-in-left",
  "pulse": "TimelineSteps-module-scss-module__iBsB6a__pulse",
  "pulse-contact": "TimelineSteps-module-scss-module__iBsB6a__pulse-contact",
  "shake-bottom": "TimelineSteps-module-scss-module__iBsB6a__shake-bottom",
  "slide-again": "TimelineSteps-module-scss-module__iBsB6a__slide-again",
  "slide-in-right": "TimelineSteps-module-scss-module__iBsB6a__slide-in-right",
  "step": "TimelineSteps-module-scss-module__iBsB6a__step",
  "stepBox": "TimelineSteps-module-scss-module__iBsB6a__stepBox",
  "stepContent-entrance": "TimelineSteps-module-scss-module__iBsB6a__stepContent-entrance",
  "track": "TimelineSteps-module-scss-module__iBsB6a__track",
});
